// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".memberFormListWrap{box-sizing:border-box;width:100%;position:relative;overflow:auto}.memberFormListCard{line-height:50px;border-bottom:1px solid #ccc;padding:0 1rem;background:#fff;position:relative}", ""]);
// Exports
module.exports = exports;
